import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRenameThemeMutation = createMutationHook(ShopRendererApiClient.renameTheme, {
  mutationKey: ['renameTheme'],
})
